export default __webpack_public_path__ + "static/media/faq.192243d8.svg";